import { useMedia } from 'react-use';

import { useBreakpoints } from '@pkg/hooks';

import { useNavigationStore } from '@app/store/zustand';

import { useFantasyLineupBreakpoint } from './useFantasyLineupBreakpoint';

export const useFantasyLeaderboardBreakpoints = () => {
    const { isMobile } = useBreakpoints();
    const isMinimized = useNavigationStore((state) => state.isMinimized);
    const { isWideDesktop } = useFantasyLineupBreakpoint();

    const globalNavMinimized = isMinimized || isMobile;
    const lineupSidebarMinimized = !isWideDesktop;

    let yatsBreakpoint: number | undefined;
    let topPicksBreakpoint: number | undefined;
    let chevronBreakpoint: number | undefined;
    let startingBreakpoint: number | undefined;
    let profitLossPercentBreakpoint: number | undefined;

    // expanded view
    let itemsBreakpoint: number | undefined;
    let initialValueBreakpoint: number | undefined;
    let addButtonBreakpoint: number | undefined;

    if (globalNavMinimized) {
        yatsBreakpoint = !lineupSidebarMinimized ? 1653 : 1130;
        topPicksBreakpoint = !lineupSidebarMinimized ? 1610 : 1038;
        chevronBreakpoint = !lineupSidebarMinimized ? 1500 : 944;
        startingBreakpoint = !lineupSidebarMinimized ? 1450 : 920;

        itemsBreakpoint = !lineupSidebarMinimized ? 1805 : 1236;
        initialValueBreakpoint = !lineupSidebarMinimized ? 1605 : 1038;
        addButtonBreakpoint = !lineupSidebarMinimized ? 1400 : 944;

        profitLossPercentBreakpoint = !lineupSidebarMinimized ? 1653 : 1038;
    } else {
        yatsBreakpoint = !lineupSidebarMinimized ? 1925 : 1399;
        topPicksBreakpoint = !lineupSidebarMinimized ? 1850 : 1325;
        chevronBreakpoint = !lineupSidebarMinimized ? 1738 : 1206;
        startingBreakpoint = !lineupSidebarMinimized ? 1710 : 1185;

        itemsBreakpoint = !lineupSidebarMinimized ? 1950 : 1432;
        initialValueBreakpoint = !lineupSidebarMinimized ? 1790 : 1232;
        addButtonBreakpoint = !lineupSidebarMinimized ? 1690 : 1170;

        profitLossPercentBreakpoint = !lineupSidebarMinimized ? 1653 : 1038;
    }

    const hideYats = useMedia(`(max-width: ${yatsBreakpoint}px)`);
    const hideTopPicks = useMedia(`(max-width: ${topPicksBreakpoint}px)`);
    const hideChevron = useMedia(`(max-width: ${chevronBreakpoint}px)`);
    const hideStarting = useMedia(`(max-width: ${startingBreakpoint}px)`);
    const hideCurrentTotal = isMobile;

    const hideItems = useMedia(`(max-width: ${itemsBreakpoint}px)`);
    const hideInitialValue = useMedia(`(max-width: ${initialValueBreakpoint}px)`);
    const hideAddButton = useMedia(`(max-width: ${addButtonBreakpoint}px)`);
    const hideCurrentValue = isMobile;

    const hideProfitLossPercent = useMedia(`(max-width: ${profitLossPercentBreakpoint}px)`);

    return {
        hideYats,
        hideTopPicks,
        hideChevron,
        hideStarting,
        hideCurrentTotal,
        hideItems,
        hideInitialValue,
        hideAddButton,
        hideCurrentValue,
        hideProfitLossPercent,
    };
};
